import Image from 'next/image';

export type StepItemProps = {
  order: number;
  title: string;
  subtitle: string;
  image: string;
  onClick?: () => void;
};

export function ProcessStepsCarouselMobileItem({
  order,
  title,
  subtitle,
  onClick,
  image,
}: StepItemProps) {
  return (
    <div className="group rounded-2xl bg-[linear-gradient(113deg,#2563EB_-45.06%,#0369A1_35.89%,#05195E_104.36%)] shadow-[0_-37px_50px_0_rgba(0,0,0,0.50)] overflow-clip px-4.5 pt-6.5 pb-8">
      <div className="relative cursor-pointer transition-all duration-300 border-l-2 border-transparent">
        <div className="absolute left-0 top-2 w-px h-full flex flex-col items-center">
          <span className="block w-4 h-4 text-xs leading-4 text-center text-white font-medium tracking-[0.18px]">
            {order}
          </span>
          <div className="grow bg-white/50 w-px mt-1" />
        </div>

        <div
          className={`pl-4 transition-opacity duration-300 text-white flex flex-col gap-4 pb-4 group-last:pb-0`}
        >
          <div
            className="text-[32px] *:text-[32] font-serif *:font-serif tracking-[-0.64px] *:tracking-[-0.64px] leading-[120%] *:leading-[120%] font-semibold *:font-semibold"
            dangerouslySetInnerHTML={{ __html: title }}
            onClick={onClick}
          />

          <div
            className="text-base *:text-base leading-normal *:leading-normal"
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
          <Image
            src={image}
            alt={title}
            width={600}
            height={600}
            className="w-full h-full object-cover rounded-2xl aspect-square"
            sizes="(max-width: 1024px) 100vw, 50vw"
          />
        </div>
      </div>
    </div>
  );
}
